import useAcceptanceAdvanced from '../api/useAcceptanceAdvanced';
import useMarkAcceptanceErrorAsViewed from '../api/useMarkAcceptanceErrorAsViewed';

const useAcceptanceAdvancedContext = (companyId: string) => {
  const { acceptanceAdvanced, loading, refetch } = useAcceptanceAdvanced(companyId);
  const { request: markAcceptanceErrorAsViewed } = useMarkAcceptanceErrorAsViewed(refetch);

  return {
    acceptanceAdvanced,
    loading,
    markAcceptanceErrorAsViewed,
  };
};

export default useAcceptanceAdvancedContext;
